import { render, staticRenderFns } from "./depotList.vue?vue&type=template&id=6424b0b0&scoped=true"
import script from "./depotList.vue?vue&type=script&lang=js"
export * from "./depotList.vue?vue&type=script&lang=js"
import style0 from "./depotList.vue?vue&type=style&index=0&id=6424b0b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6424b0b0",
  null
  
)

export default component.exports